import React from 'react';
import { ChevronDown } from '@velocity-exchange/icons';
import { WithClassName } from 'src/utils/UtilityTypes';
import { cj } from 'src/utils/classNames';

interface Props extends WithClassName {
	direction: 'up' | 'down' | 'left' | 'right';
	size?: number;
	colour?: string;
}

export default function Chevron({ direction, colour, size, className }: Props) {
	const rotateClassName = {
		up: 'rotate-180',
		right: '-rotate-90',
		down: 'rotate-0',
		left: 'rotate-90',
	}[direction];

	return (
		<ChevronDown
			className={cj('transition-transform', rotateClassName, className)}
			color={colour}
			size={size}
		/>
	);
}
